import { ReactNode } from "react";
import styled from "@emotion/styled";
import { Flex, Text } from "styles/utility-components";

import UIcon from "lib/icons/untitled_ui/UIcon";

type Props = {
  title: string;
  description: string;
  actionNode?: ReactNode;
  width?: number | string;
};

export function LoadingState({ title, description, actionNode, width = "450px" }: Props) {
  return (
    <LoadingContainer width={width}>
      <UIcon icon="spinner" color="sysPrimaryDefault" size={48} />
      <Flex alignItems="center" flexDirection="column" gap={8}>
        <CenteredText bold h3>
          {title}
        </CenteredText>
        <CenteredText>{description}</CenteredText>
      </Flex>
      {actionNode}
    </LoadingContainer>
  );
}

const LoadingContainer = styled(Flex)<{ width: number | string }>(({ width }) => ({
  width,
  gap: 24,
  flexDirection: "column",
  alignItems: "center",
}));

const CenteredText = styled(Text)({
  textAlign: "center",
});
